import { render, staticRenderFns } from "./formProposta_p0.vue?vue&type=template&id=8d46d77e"
import script from "./formProposta_p0.vue?vue&type=script&lang=js"
export * from "./formProposta_p0.vue?vue&type=script&lang=js"
import style0 from "./formProposta_p0.vue?vue&type=style&index=0&id=8d46d77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports